<script setup>
import { ref, nextTick, onMounted, computed } from 'vue';

const emit = defineEmits(['send']);
const message = ref('');
const textareaRef = ref(null);

const hasText = computed(() => message.value.trim().length > 0);

const adjustHeight = () => {
  if (!textareaRef.value) return;

  // Reset height to auto to get the correct scrollHeight
  textareaRef.value.style.height = 'auto';
  // Set the height to the scrollHeight
  textareaRef.value.style.height = `${textareaRef.value.scrollHeight}px`;
};

const sendMessage = () => {
  if (message.value.trim()) {
    emit('send', message.value);
    message.value = '';
    // Reset textarea height after sending
    nextTick(() => {
      adjustHeight();
    });
  }
};

const handleInput = () => {
  nextTick(adjustHeight);
};

const handleEnterKey = event => {
  if (event.isComposing) return;
  event.preventDefault();
  sendMessage();
};

onMounted(() => {
  nextTick(adjustHeight);
});
</script>

<template>
  <form class="relative" @submit.prevent="sendMessage">
    <textarea
      ref="textareaRef"
      v-model="message"
      :placeholder="$t('CAPTAIN.COPILOT.SEND_MESSAGE')"
      :class="[
        'w-full reset-base bg-n-alpha-3 ltr:pl-4 rtl:pr-4 py-3 text-sm border border-n-weak rounded-lg focus:outline-0 focus:outline-none focus:ring-2 focus:ring-n-blue-11 focus:border-n-blue-11 resize-none overflow-hidden max-h-[200px] mb-0 text-n-slate-12',
        hasText ? 'ltr:pr-12 rtl:pl-12' : 'ltr:pr-4 rtl:pl-4',
      ]"
      rows="1"
      @input="handleInput"
      @keydown.enter.exact="handleEnterKey"
    />
    <button
      v-show="hasText"
      class="absolute ltr:right-2 rtl:left-2 bottom-2 h-8 w-8 flex items-center justify-center text-white bg-[#00a884] hover:bg-[#008f6f] rounded-full transition-all shadow-sm"
      type="submit"
      :aria-label="$t('CAPTAIN.COPILOT.SEND_MESSAGE')"
    >
      <i class="i-ph-paper-plane-right-fill text-base" />
    </button>
  </form>
</template>
